import React from "react";
import "./styles.css";

const GroupBDRBiologists = ({ description }) => {
    return (
        <div className="userTag biologist">
            <p>{description ? description : "BDR BIOLOGIST"}</p>
        </div>
    );
};

export default GroupBDRBiologists;